const ACRONYM_AN_INITIALS = new Set(["a", "e", "f", "h", "i", "l", "m", "n", "o", "r", "s", "x"]);

const ACRONYM_A_INITIALS = new Set(["u", "y", "w"]);

const AN_EXCEPTIONS = /^(honest|honou?r|hour|heir)\b/i;
const A_EXCEPTIONS = /^(euro|one\b|once\b|uni([^nmd]|$)|u[bcfhjkqrst][aeiou]|use|user|usual|ut[ei]|ubiq)/i;

const firstWord = (value: string) => value.trim().split(/\s+/)[0]?.replace(/^[^a-z0-9]+/i, "") ?? "";

const isAcronym = (word: string) => /^[A-Z](?:[A-Z.]|\d)*$/.test(word);

const getIndefiniteArticle = (value?: string | null): "a" | "an" => {
  const word = firstWord(value ?? "");

  if (!word) return "a";
  if (AN_EXCEPTIONS.test(word)) return "an";
  if (A_EXCEPTIONS.test(word)) return "a";

  if (isAcronym(word)) {
    const initial = word[0].toLowerCase();
    if (ACRONYM_A_INITIALS.has(initial)) return "a";
    if (ACRONYM_AN_INITIALS.has(initial)) return "an";
  }

  return /^[aeiou]/i.test(word) ? "an" : "a";
};

const withIndefiniteArticle = (value: string): string => `${getIndefiniteArticle(value)} ${value.trim()}`;

export { getIndefiniteArticle, withIndefiniteArticle };
